import(/* webpackMode: "eager" */ "/vercel/path0/app/color-picker/page.tsx");
